import { render, staticRenderFns } from "./ChatContainerComponent.vue?vue&type=template&id=17f65a54"
import script from "./ChatContainerComponent.vue?vue&type=script&lang=ts"
export * from "./ChatContainerComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports